import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Dna = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 3.978V3C26 2.448 25.552 2 25 2C24.448 2 24 2.448 24 3V3.978C24 8.019 21.793 11.725 18.239 13.65L16 14.863L13.761 13.65C12.125 12.764 10.776 11.5 9.79495 10H17.126C17.678 10 18.126 9.552 18.126 9C18.126 8.448 17.678 8 17.126 8H8.76195C8.50995 7.357 8.31795 6.687 8.18995 6H19.127C19.679 6 20.127 5.552 20.127 5C20.127 4.448 19.679 4 19.127 4H8.00195C8.00195 3.993 8.00195 3.985 8.00195 3.978V3C8.00195 2.448 7.55395 2 7.00195 2C6.44995 2 6.00195 2.448 6.00195 3V3.978C6.00195 8.754 8.61095 13.134 12.81 15.409L13.902 16L12.81 16.591C8.60995 18.866 6.00195 23.246 6.00195 28.022V29C6.00195 29.552 6.44995 30 7.00195 30C7.55395 30 8.00195 29.552 8.00195 29V28.022C8.00195 23.981 10.209 20.275 13.763 18.35L16.002 17.137L18.241 18.35C19.877 19.236 21.226 20.5 22.207 22H14.751C14.199 22 13.751 22.448 13.751 23C13.751 23.552 14.199 24 14.751 24H23.24C23.493 24.643 23.684 25.313 23.813 26H12.751C12.199 26 11.751 26.448 11.751 27C11.751 27.552 12.199 28 12.751 28H24.001C24.001 28.008 24.001 28.015 24.001 28.022V29C24.001 29.552 24.449 30 25.001 30C25.553 30 26.001 29.552 26.001 29V28.022C26.001 23.246 23.392 18.866 19.193 16.591L18.101 15.999L19.193 15.408C23.393 13.133 26.001 8.753 26.001 3.977L26 3.978Z" />
	</svg>
);

export default Dna;
